import React, {FC, ReactNode, useMemo} from 'react';
import styled from 'styled-components';

import {
  AnswerFolderDropdownBox,
  AnswerFolderDropdownBoxProps,
} from '../../components/common/dropdowns/answerFolders/answerFolderDropdownBox';
import {useAppSelector} from '../../helpers/reduxHelpers';
import {AnswerFolderModel} from '../../models/api/answerFolderModel';
import {makeGetAnswerFolder} from '../../store/data/answerFolders/answerFolderSelectors';
import {SettingsFieldLine} from '../common/settingsFieldLine';

/*
 * Props.
 */

interface SettingsSingleAnswerParentFolderFieldProps
  extends Omit<AnswerFolderDropdownBoxProps, 'selectedFolder'> {
  title: ReactNode;
  subtitle: ReactNode;
  editedFolder: AnswerFolderModel | undefined;
}

/*
 * Style.
 */

const StyledParentTagPickerDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 240px;
`;

/*
 * Component.
 */

export const SettingsSingleAnswerParentFolderField: FC<SettingsSingleAnswerParentFolderFieldProps> = (
  props,
) => {
  const getSelectedFolder = useMemo(
    () => makeGetAnswerFolder(() => props.selectedFolderId),
    [props.selectedFolderId],
  );
  const selectedFolder = useAppSelector(getSelectedFolder);

  const renderParentTagPicker = () => (
    <StyledParentTagPickerDiv>
      <AnswerFolderDropdownBox
        onFolderSelect={props.onFolderSelect}
        selectedFolderId={props.selectedFolderId}
        selectedFolder={selectedFolder}
        allAvailableNamespaces={props.allAvailableNamespaces}
        selectedNamespace={props.selectedNamespace}
        currentFolder={props.editedFolder}
        shouldHideLabel
        dropdownWidth={300}
      />
    </StyledParentTagPickerDiv>
  );

  return (
    <SettingsFieldLine title={props.title} subtitle={props.subtitle} content={renderParentTagPicker()} />
  );
};
